import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.every.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import { transformStr3, handleHttp, getformListItemsdata, getformListItemsdatas, insertStr, setImgsize, loadScript } from "@/utils/utils";
import mapassembly from '@/view/map/custom/mapassembly';
export default {
  name: 'tgx',
  meta: {
    title: '铜鼓县地图'
  },
  components: {
    mapassembly
  },
  data() {
    return {
      fid: this.$route.query.fid,
      formUserId: this.$route.query.formUserId,
      mapconfigform: {
        formId: '177623',
        pageSize: 1
      },
      mapdataform: {
        formId: '165054',
        page: 1,
        limit: 100,
        searchStr: ''
      },
      mapcfData: '',
      map: null,
      mapconfig: {
        mapMinZoom: 10,
        mapMaxZoom: 13,
        center: [],
        extent: [],
        currentZoom: 10
      },
      mapconfigdatas: {},
      // 地图管理配置对象
      isApp: false,
      page: 1,
      pauseTime: 5,
      // 无操作停留时间
      countDown: null,
      query: '',
      searchKey: '',
      listFlag: false,
      dataList: [],
      descFlag: false,
      dataListCopy: [],
      nodataFlag: false,
      linkdata: {},
      isItemClick: false
    };
  },
  created() {
    loadScript('https://noteyd.chaoxing.com/res/plugin/ueditor4thirdparty/multieditor.js');
  },
  mounted() {
    document.body.style.overflow = 'hidden';
    if (document.body.clientWidth < 926) this.isApp = true;
    this.query = this.$route.query;
    this.getmapconfigform();
  },
  watch: {},
  methods: {
    // 获取地图配置数据 方便多个地图配置
    getmapconfigform() {
      let that = this;
      this.mapconfigform.deptId = this.fid;
      this.$api.singleformUserId(this.fid, this.mapconfigform.formId, this.formUserId).then(res => {
        // console.log(res)
        that.currentformuser = res.formUserList[0];
        that.mapcfData = res.formUserList[0].formData;
        if (res.formUserList.length > 0) {
          that.mapcfData.forEach(item => {
            that.mapconfigdatas[transformStr3(item.alias)] = that.getformitemsdata(item);
          });
          that.linkdata.img = that.mapconfigdatas[50];
          that.linkdata.link = that.mapconfigdatas[51];
          console.log(that.mapconfigdatas);
        }
      });
    },
    getformitemsdata(data) {
      let typekey = 'val';
      if (!data.values) return '';
      if (data.compt === 'imagebox') typekey = 'fileUrl';
      return data.values.length && data.values[0] ? data.values[0][typekey] : '';
    },
    /*
    ** 显示文物简介 2024/01/24
    */
    descList() {
      console.log(MultiEditor);
      this.descFlag = true;
      MultiEditor.init('detail');
      console.log(this.mapconfigdatas[52]);
      MultiEditor.renderRichtext('editor1', this.mapconfigdatas[52] !== '' ? this.mapconfigdatas[52] : '<p class="nodata color000">暂无数据</p>');
    },
    /*
    ** 显示文物列表 2024/01/24
    */
    showList() {
      this.listFlag = true;
      /* 获取全部不可移 */
      var searchStr = {};
      if (this.formUserId === '842035648') {
        searchStr = {
          filters: [{
            alias: "title",
            compt: "editinput",
            express: '!==',
            val: '00001'
          }],
          model: 0
        };
      } else {
        searchStr = {
          filters: [{
            alias: "title",
            compt: "editinput",
            express: '!==',
            val: '00001'
          }, {
            alias: "title",
            compt: "editinput",
            express: '===',
            val: this.mapconfigdatas.onlyid
          }],
          model: 0
        };
      }
      this.mapdataform.searchStr = encodeURI(JSON.stringify(searchStr));
      this.getmapdataform();
    },
    /*
    ** 获取地图点数据 2024/01/24
    */
    getmapdataform() {
      let that = this;
      this.mapdataform.deptId = this.fid;
      this.$api.singleadvanceSearch(this.mapdataform).then(res => {
        if (that.mapdataform.page === 1) that.nodataFlag = res.dataList.length > 0 ? false : true;
        if (res.dataList.length > 0) {
          that.dataformat(res);
          if (res.totalPage > 1) {
            that.mapdataform.page++;
            if (res.totalPage >= that.mapdataform.page) that.getmapdataform();
          }
        }
      }).catch(e => {
        console.log(e);
      });
    },
    dataformat(res) {
      res.dataList.forEach((item, index) => {
        let itemformdata = item.formIdValueData;
        let itemformat = {};
        Object.keys(itemformdata).forEach(key => {
          itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
        });
        item.itemformdata = itemformat;
        item.itemformdata.address = itemformat.route.length > 0 && itemformat.route[0].address ? itemformat.route[0].address : '';
        item.itemformdata.image = setImgsize(itemformat[4][0], 160, 104);
      });
      if (this.mapdataform.page === 1) {
        this.dataList = res.dataList.filter(item => {
          return item.itemformdata['42'] !== '仅展示';
        });
      } else {
        this.dataList.concat(res.dataList.filter(item => {
          return item.itemformdata['42'] !== '仅展示';
        }));
      }
      // 不可移总地图 列表 去掉当前地点数据
      if (this.formUserId === '842035648') {
        this.dataList = this.dataList.filter(item => {
          return item.itemformdata.title !== '00008';
        });
      }
      this.dataListCopy = this.dataList;
    },
    /*
    ** 列表点击 2024/01/24
    */
    ItemHandle(val) {
      this.isItemClick = true;
      this.listFlag = false;
      this.$refs.map.markerclick({
        id: val.id
      });
    },
    /*
    ** 关闭弹窗 2024/01/24
    */
    closeHandle() {
      if (this.isItemClick) {
        this.listFlag = true;
        this.isItemClick = false;
      }
    },
    /*
    ** 搜索当前列表对应数据 2024/01/24
    */
    gosearch() {
      let searchform = {
        placeName: this.searchKey
      };
      let filters = {};
      Object.keys(searchform).forEach(item => {
        filters[item] = searchform[item] === '' ? [] : searchform[item].toString().split(',');
      });
      let cacheData = JSON.parse(JSON.stringify(this.dataListCopy));
      let filterArray = this.multiFilter(cacheData, filters);
      let data = JSON.parse(JSON.stringify(filterArray));
      this.dataList = data;
      this.nodataFlag = this.dataList.length > 0 ? false : true;
    },
    /*
    ** 静态数据筛选 2024/01/24
    */
    multiFilter(array, filters) {
      const filterKeys = Object.keys(filters);
      return array.filter(item => {
        let itemflag = filterKeys.every(key => {
          // 自定义判断
          if (key === 'placeName') return !!~item.itemformdata[key].indexOf(filters[key]);
          if (!filters[key].length) return true;
          return !!~filters[key].indexOf(item.itemformdata[key]);
        });
        return itemflag;
      });
    },
    /*
    ** 返回不可移首页
    */
    goLink(val) {
      window.open(val);
    },
    /*
    ** 返回首页
    */
    goHome(val) {
      window.open(location.protocol + '//' + location.host + location.pathname + '#/tgx?formId=1135698&fid=113693&formUserId=842035648');
    }
  }
};